import { TestimonialCarousel } from "./TestimonialCarousel";
import { testimonialData } from "../utils";
import { motion } from "framer-motion";
import { fadeIn } from "../utils";

export const Testimonial = () => {
  const { title, subtitle, slider, modelImg } = testimonialData;

  return (
    <section className="bg-testimonial bg-cover bg-no-repeat relative top-[340px] lg:top-[390px] z-10 h-[800px] pt-[60px] md:pt-[120px]">
      <div id='testimonials' className="container mx-auto">
        <motion.div
          variants={fadeIn('up', 'tween', 0.2, 1.6)}
          initial='hidden'
          whileInView='show'
          className="text-center capitalize flex flex-col items-center"
        >
          <h2 className="h2 text-white">{title}</h2>
          <p className="text-white/70 capitalize mb-8">{subtitle}</p>

          <div className="mb-12">
            <img src={modelImg} alt={title} />
          </div>
        </motion.div>

        <motion.div
          variants={fadeIn('up', 'tween', 0.4, 1.6)}
          initial='hidden'
          whileInView='show'
          className="flex justify-center items-center"
        >
          <TestimonialCarousel slider={slider} />
        </motion.div>
      </div>
    </section>
  );
};
